import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from 'features/shared/components/common/WhatsAppButton';
import ZohoHelpdesk from 'features/shared/components/common/ZohoHelpdesk';
import Container from '@mui/material/Container';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

export default function Layout({ children }){
  const location = useLocation();
  const isDominios = location.pathname.startsWith('/dominios');
  const isPanel = location.pathname.startsWith('/panel');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', position: 'relative' }}>
      <Header />
      
      <Box component="main" sx={{ flexGrow: 1, pt: { xs: 10, md: 14 } }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          >
            {isDominios ? (
              <Box sx={{ minHeight: '60vh', width: '100%', overflowX: 'hidden' }}>
                {children}
              </Box>
            ) : (
              <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 }, minHeight: '60vh' }}>
                {children}
              </Container>
            )}
          </motion.div>
        </AnimatePresence>
      </Box>

      <Footer />
      {!isPanel && <WhatsAppButton />}
      {!isPanel && <ZohoHelpdesk />}
    </Box>
  );
}